<template>
  <div class="widget__content-center widget__content-center--flex">
    <IconVisits v-if="widget.code_name === 'AverageVisits'" />
    <IconRepeats v-if="widget.code_name === 'AverageRepeats'" />

    <div class="widget__bignumber">{{formatNumber(displayData, 2)}}</div>

    <p v-if="area?.name === 'Cluster'">
      {{ widget.name }} per visitor across the cluster
    </p>
    <div v-else class="widget__label widget__label-thin">
      {{ widget.name }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { WidgetFilter, WidgetSetting, WidgetTypeAverageWidget } from '@/types/Widget';
import IconVisits from '@/icons/analytics/IconVisits.svg?component';
import IconRepeats from '@/icons/analytics/IconRepeats.svg?component';
import { formatNumber } from '@/utils/formatNumbers';
const props = defineProps<{
  widget: WidgetTypeAverageWidget,
  area?: WidgetFilter,
  time?: WidgetFilter,
  zone?: WidgetSetting,
  cluster?: WidgetSetting
}>();

const displayData = computed(() => {
  const areaName = props.area?.name;
  const clusterId = props.cluster?.id;

  let baseData = props.widget.data['Site'];

  if (!baseData) {
    return '';
  }

  if (areaName === 'Cluster') {
    if (clusterId) {
      baseData = props.widget.data[areaName][clusterId];
      return baseData['Total'];
    }
  }

  return baseData['Total'];
});
</script>
